import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 px-6 py-6 mt-6 bg-gray-100" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "grid gap-4 px-6 pb-6 bg-gray-100 md:grid-cols-2" }
const _hoisted_7 = { class: "md:col-span-1" }
const _hoisted_8 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "md:col-span-1" }
const _hoisted_11 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "md:col-span-1" }
const _hoisted_14 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "md:col-span-1" }
const _hoisted_17 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "md:col-span-1" }
const _hoisted_20 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "md:col-span-1" }
const _hoisted_23 = { class: "flex mt-1 rounded-md shadow-sm" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "py-3 mt-10 text-center" }

import {computed, defineComponent, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetProfileOutsideLinks,
    GetProfileOutsideLinksResponse, UpdateProfileOutsideLinks,
} from "@/dtos";
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import {EyeIcon} from '@heroicons/vue/20/solid';
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileOutsideLinksSettings',
  setup(__props) {

// @ts-ignore
const responseStatus = ref(null);
const profile: Ref<GetProfileOutsideLinksResponse> = ref(new GetProfileOutsideLinksResponse());

onMounted(async () => {
    await client.get<GetProfileOutsideLinksResponse>(new GetProfileOutsideLinks())
        .then(response => {
            profile.value = response;
        });
});

const isSubmitting = ref(false);
let updateSuccessful = ref(false);
const updateProfileOutsideLinks = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    let request = profile.value;
    await client.post<ResponseStatus>(new UpdateProfileOutsideLinks(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

    isSubmitting.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
      _createElementVNode("div", _hoisted_1, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "space-y-1" }, [
          _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, [
            _createTextVNode("Outside Links "),
            _createElementVNode("sup", { class: "text-electric-700" }, "PRO")
          ]),
          _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" }, "Display web links on your profile")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              class: "block mb-1 text-sm font-medium text-gray-700",
              for: "web"
            }, "Personal Website", -1)),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "web",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profile.value.web) = $event)),
                class: "block w-full px-3 py-2 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs rounded-l-md",
                name: "web",
                type: "text",
                placeholder: "Eg. https://stageagent.com"
              }, null, 512), [
                [_vModelText, profile.value.web]
              ]),
              _createElementVNode("a", {
                href: profile.value.web,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_5)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "fb"
            }, "Facebook", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("svg", {
                  fill: "currentColor",
                  class: "w-4 h-4 shrink-0 text-inherit",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                }, [
                  _createElementVNode("path", { d: "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "fb",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profile.value.fb) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "fb",
                type: "text",
                placeholder: "Eg. https://www.facebook.com/stageagentcom"
              }, null, 512), [
                [_vModelText, profile.value.fb]
              ]),
              _createElementVNode("a", {
                href: profile.value.fb,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "tw"
            }, " X (formerly Twitter) ", -1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("svg", {
                  fill: "currentColor",
                  class: "w-4 h-4 shrink-0 text-inherit",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                }, [
                  _createElementVNode("path", { d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tw",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profile.value.tw) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "tw",
                type: "text",
                placeholder: "Eg. https://x.com/stageagent"
              }, null, 512), [
                [_vModelText, profile.value.tw]
              ]),
              _createElementVNode("a", {
                href: profile.value.tw,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "in"
            }, "Instagram", -1)),
            _createElementVNode("div", _hoisted_14, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("svg", {
                  fill: "currentColor",
                  class: "w-4 h-4 shrink-0 text-inherit",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 448 512"
                }, [
                  _createElementVNode("path", { d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "in",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profile.value.in) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "in",
                type: "text",
                placeholder: "Eg. https://www.instagram.com/stageagentcom/"
              }, null, 512), [
                [_vModelText, profile.value.in]
              ]),
              _createElementVNode("a", {
                href: profile.value.in,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "yt"
            }, "Youtube", -1)),
            _createElementVNode("div", _hoisted_17, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("svg", {
                  fill: "currentColor",
                  class: "w-5 h-5 shrink-0 text-inherit",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 576 512"
                }, [
                  _createElementVNode("path", { d: "M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "yt",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profile.value.yt) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "yt",
                type: "text",
                placeholder: "Eg. https://www.youtube.com/stageagent"
              }, null, 512), [
                [_vModelText, profile.value.yt]
              ]),
              _createElementVNode("a", {
                href: profile.value.yt,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[17] || (_cache[17] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "tk"
            }, "TikTok", -1)),
            _createElementVNode("div", _hoisted_20, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("i", { class: "fab fa-tiktok" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "tk",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((profile.value.tk) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "tk",
                type: "text",
                placeholder: "Eg. https://www.tiktok.com/@stageagentcom"
              }, null, 512), [
                [_vModelText, profile.value.tk]
              ]),
              _createElementVNode("a", {
                href: profile.value.tk,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[19] || (_cache[19] = _createElementVNode("label", {
              class: "block text-sm font-medium text-gray-700",
              for: "ln"
            }, "LinkedIn", -1)),
            _createElementVNode("div", _hoisted_23, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "inline-flex items-center px-3 text-clay-800 border border-r-0 border-clay-500 rounded-l-md bg-gray-50 sm:text-sm" }, [
                _createElementVNode("i", { class: "fab fa-linkedin" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ln",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((profile.value.ln) = $event)),
                class: "flex-1 block w-full min-w-0 px-3 placeholder-gray-400 bg-white border rounded-none shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm placeholder:text-xs",
                name: "ln",
                type: "text",
                placeholder: "Eg. https://www.linkedin.com/company/stageagent"
              }, null, 512), [
                [_vModelText, profile.value.ln]
              ]),
              _createElementVNode("a", {
                href: profile.value.ln,
                target: "_blank",
                class: "relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-clay-500 hover:bg-gray-50",
                "aria-label": "View profile",
                role: "link"
              }, [
                _createVNode(_unref(EyeIcon), { class: "w-6 h-6 text-clay-800" })
              ], 8, _hoisted_24)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(SaButton, {
          onClick: _withModifiers(updateProfileOutsideLinks, ["prevent"]),
          loading: isSubmitting.value,
          variant: "primary"
        }, null, 8, ["loading"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: _unref(updateSuccessful),
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})